<template>
  <nav
    class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
  >
    <div class="hidden sm:block">
      <p class="text-sm leading-5 text-gray-700">
        Showing
        <span class="font-medium">{{ startingPagerValue }} </span>
        to
        <span class="font-medium">{{ pagerValue }} </span>
        of
        <span class="font-medium">{{ page.total }} </span>
        results
      </p>
    </div>
    <div class="flex-1 flex justify-between sm:justify-end">
      <a
        v-if="page.page - 1 >= 1"
        class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
        @click="loadPrevPage"
      >
        Previous
      </a>
      <a
        v-if="page.pages > page.page"
        class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
        @click="loadNextPage"
      >
        Next
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    page: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    pagerValue() {
      const page = this.page;
      if (page) {
        if (page.total < page.limit) {
          return page.total;
        }
        if (page.page === 1) {
          return page.limit;
        }
        return page.page * page.limit;
      }
      return 0;
    },
    startingPagerValue() {
      const page = this.page;
      if (page) {
        if (page.page === 1) {
          return 1;
        }
        return (page.page - 1) * page.limit;
      }
      return 1;
    }
  },
  methods: {
    loadNextPage() {
      this.$emit("pageChanged", Number(this.page.page) + 1);
    },
    loadPrevPage() {
      this.$emit("pageChanged", Number(this.page.page) - 1);
    }
  }
};
</script>

<style lang="scss" scoped></style>
